


































































import Vue from "vue";
import iwInputSelect from "@/shared/components/buildingBlocks/InputSelect.vue";
import iwDropdown from "@/shared/components/Dropdown.vue";
import { mapState } from "vuex";

export default Vue.extend({
    components: {
        iwInputSelect: iwInputSelect,
        iwDropdown: iwDropdown
    },

    props: {
        isMobile: {
            type: Boolean,
            required: false,
            default: true
        }
    },

    data: function() {
        return {
            triggerStyle: "filter--mobile" as string,
            selectedSortType: "lastActionDate" as string,
            internalSortType: "lastActionDate" as string
        };
    },

    computed: {
        ...mapState("MyClassifiedsModule", ["sort"]),

        options: function(): Array<Record<string, unknown>> {
            return [
                {
                    "label": this.$t("last_update"),
                    "value": "lastActionDate",
                },
                {
                    "label": this.$t("last_added"),
                    "value": "creationDate"
                },
                {
                    "label": this.$t("postal_code"),
                    "value": "postalCode"
                }
            ];
        },
        title: function(): string {
            const transKeys: Record<string, string> = {
                lastActionDate: "last_update",
                creationDate: "last_added",
                postalCode: "postal_code",
            };

            return transKeys[this.sort];
        }
    },

    mounted: function() {
        this.selectedSortType = this.sort;
        this.internalSortType = this.sort;

        if(this.isMobile) {
            this.triggerStyle = "filter--mobile";
        } else {
            this.triggerStyle = "filter filter--result-list";
        }
    },

    methods: {
        filterValue: function (status: string) {
            this.$store.commit("MyClassifiedsModule/setSort", status);
            this.$emit("filter-value", status);
        },
        apply: function()  {
            this.$store.commit("MyClassifiedsModule/setSort", this.internalSortType);
            this.$emit("filter-value", this.internalSortType);
            (this.$refs.dropdownSort as Vue & { closeList: () => void }).closeList();
        },
        closeMobileOverlay: function() {
            if(document.documentElement.classList.contains("js-fullscreen")){
                document.documentElement.classList.remove("js-fullscreen");
            }
        }
    }
});
